<script lang="ts">
  import { Modal } from 'svelte-simple-modal';
  import { fly } from 'svelte/transition';
</script>

<Modal
  closeButton={false}
  styleBg={{
    backdropFilter: 'blur(1.5px)',
    background: 'rgba(0, 0, 0, 0.15)'
  }}
  styleWindow={{
    borderRadius: 0,
    minWidth: '300px'
  }}
  styleWindowWrap={{
    margin: '0 1rem'
  }}
  styleContent={{
    padding: '2rem 2rem'
  }}
  transitionWindow={fly}
  transitionWindowProps={{
    duration: 500,
    y: 500
  }}
>
  <slot />
</Modal>
